import firebase from './firebase'

let USER = null
let USER_EMAIL = ""
let USER_TOKEN = ""

function refreshLoginToken() {
  USER.getIdToken(true).then((idToken) => {
    USER_TOKEN = idToken
  })
}

export default class {
  static init() {
    return new Promise((resolve) => {
      // Check if there is not token provided
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("token")) {
        document.location.href = '/auth/' + window.location.search + "&redirectURL=" + window.location.pathname
        return
      }

      // resolve(); return; // DISABLE AUTH
      if ((window.location.search || []).indexOf("disableAuth") > -1) {
        resolve()
        return
      }
      firebase.auth().onAuthStateChanged(function (user) {
        if (!user) {
          // not logged in - redirect
          document.location.href = '/auth/' + window.location.search
          return
        }
        USER = user
        USER_EMAIL = user.email
        // Request token
        user.getIdToken().then((idToken) => {
          USER_TOKEN = idToken
          setInterval(refreshLoginToken, 1000 * 60 * 30) // 55 minutes
          resolve()
        })
      }, function (error) {
        throw error
      })
    })
  }

  // static refreshLoginToken() {
  //   return new Promise((resolve) => {
  //     USER.getIdToken().then((idToken) => {
  //       USER_TOKEN = idToken
  //       resolve()
  //     })
  //   })
  // }

  static logout() {
    return new Promise((resolve) => {
      firebase.auth().signOut().then(function () {
        resolve()
      }, function (error) {
        throw error
      })
    })
  }

  static getUserEmail() {
    return USER_EMAIL
  }

  static getUserToken() {
    return USER_TOKEN
  }

  static getAuthorizationHeader() {
    let userTokenEncoded = btoa(`${USER_EMAIL}:${USER_TOKEN}`)
    return `Basic ${userTokenEncoded}`
  }

}
